import { useEffect } from 'react'
import PropTypes from 'prop-types'

const ReviveAds = ({ zoneId, reviveId, className }) => {
  const scriptSrc = '//servedby.revive-adserver.net/asyncjs.php'
  const ReviveId = reviveId || ''

  useEffect(() => {
    const existingScript = document.querySelector(`script[src="${scriptSrc}"]`)

    if (!existingScript) {
      const script = document.createElement('script')
      script.src = scriptSrc
      script.async = true
      script.onload = () => {
        if (window?.reviveAsync?.[ReviveId]?.refresh) {
          window.reviveAsync[ReviveId].refresh()
        }
      }
      document.body.appendChild(script)
    } else {
      // Script already exists; just trigger refresh
      if (window?.reviveAsync?.[ReviveId]?.refresh) {
        window.reviveAsync[ReviveId].refresh()
      }
    }
  }, [ReviveId])

  return (
    <div className={className}>
  <ins data-revive-zoneid={zoneId} data-revive-id={ReviveId}></ins>
  </div>
  )
}

ReviveAds.propTypes = {
  zoneId: PropTypes.string.isRequired,
  reviveId: PropTypes.string,
  className: PropTypes.string
}

export default ReviveAds
